// Components - UI
import UserIcon from '@/components/ui/UserIcon/UserIcon.vue';
import IssueCount from '@/components/ui/IssueCount/IssueCount.vue';
import ReviewStars from '@/components/ui/ReviewStars/ReviewStars.vue';
import WashroomsCount from '@/components/ui/WashroomsCount/WashroomsCount.vue';
import SubscriptionLevel from '@/components/ui/SubscriptionLevel/SubscriptionLevel.vue';
import PercentageCardContents from '@/components/ui/PercentageCardContents/PercentageCardContents.vue';
import ListViewMap from '@/components/ui/ListViewMap/ListViewMap.vue';

// Services
import ServiceRelationshipsService from '@/services/ServiceRelationshipsService.js';
import MultisitesService from '@/services/MultiSitesService.js';
import RetailersService from '@/services/RetailersService.js';
import IssuesService from '@/services/IssuesService.js';

// Mixins
import StaggerEntranceTransition from '@/components/mixins/StaggerEntranceTransition/StaggerEntranceTransition.vue';

// EventBus
import { EventBus } from '@/EventBus.js';

export default {

  name: 'Dashboard',

  mixins: [
    StaggerEntranceTransition
  ],

  components: {
    UserIcon,
    IssueCount,
    ReviewStars,
    WashroomsCount,
    SubscriptionLevel,
    PercentageCardContents,
    ListViewMap
  },

  data: function() {
    return {
      pageTitle: null,
      retailers: [],
      mode: 'list',
      searchTerm: null,
      showSearch: false
    }
  },

  created: function() {
    this.init();
  },

  mounted: function() {

  },

  beforeDestroy: function() {

  },

  methods: {
    init: function() {
      this.retailers = [];
      this.mode = 'list';
      this.searchTerm = null;
      this.showSearch = false;

      if(localStorage.getItem('userGroup') == 'multi-site-retailers') {
        let filter = {
          multiSite: localStorage.getItem('parentId')
        }

        this.loadRetailers(filter);
      }
      else if(this.$route.params.multisiteId) {
        let filter = {
          multiSite: this.$route.params.multisiteId
        }

        MultisitesService.getById(this.$route.params.multisiteId)
          .then((res) => {
            this.pageTitle = res.data.name;
          })
          .catch((err) => {});


        this.loadRetailers(filter);
      }
      else if(localStorage.getItem('userGroup') == 'service-providers') { // If we are logged in as a service provider
        ServiceRelationshipsService.getAll({serviceProvider: localStorage.getItem('parentId')})
          .then((res) => {
            let retailerIds = [];
            let filter = [];
            let filterMode = 'or';

            // Get DISTINCT ids of retailers that this SP services
            for(let i in res.data) {
              if(res.data[i].retailer && res.data[i].retailer.id) {
                if(retailerIds.indexOf(res.data[i].retailer.id) == -1) {
                  retailerIds.push(res.data[i].retailer.id);
                  filter.push({id: res.data[i].retailer.id});
                }
              }
            }

            if(filter.length > 0) {
              this.loadRetailers(filter, filterMode);
            }
          })
          .catch((err) => {
            EventBus.dispatchErrorEvent('Whoops! Something went wrong, please try again.');
          });
      }
      else {
        this.loadRetailers();
      }
    },

    loadRetailers: function(filter, filterMode) {
      let serviceProviderId = null;
      if(localStorage.getItem('userGroup') == 'service-providers') {
        serviceProviderId = localStorage.getItem('parentId');
      }

      RetailersService.getAll(filter, filterMode, null, 'name ASC')
        .then((res) => {
          if(serviceProviderId != null) {
            for (let i in res.data) {
              res.data[i].issues.filter((item) => {
                if(item.serviceProvider == serviceProviderId && (item.status == 'confirmed' || item.status ==  'resolution-in-progress' || item.status == 'resolution-awaiting-approval' || item.status == 'resolution-denied')) {
                  return true;
                }

                return false;
              });
            }
          }

          // for (let i in res.data) {
          //   let r = res.data[i];
          //
          //   let issuesFilter = {retailer: r.id};
          //
          //   if(serviceProviderId != null) {
          //     issuesFilter.serviceProvider = serviceProviderId;
          //
          //     issuesFilter.status = ['confirmed', 'resolution-in-progress', 'resolution-awaiting-approval', 'resolution-denied'];
          //   }
          //
          //   IssuesService.getAll(issuesFilter)
          //     .then((res) => {
          //       r.issues = res.data;
          //       this.retailers.push(r);
          //     });
          // }

          this.retailers = res.data;

        });
    },

    goToRetailersDetail: function(id) {
      this.$router.push('/retailers/' + id);
    },

    viewMap: function() {
      this.mode = 'map';
      this.$gmapDefaultResizeBus.$emit('resize');
    },

    viewList: function() {
      this.mode = 'list';
    },

    openSearch: function() {
      this.showSearch = true;

      // Wait for element visible before focus
      setTimeout(() => {
        this.$refs.searchInput.focus();
      }, 200);
    },

    closeSearch: function() {
      this.searchTerm = null;
      this.showSearch = false;
    }
  },

  computed: {
    search: function() {
      if(this.searchTerm && this.searchTerm.trim().length > 0) {
        return this.retailers.filter((r) => {
          if (r.name.toLowerCase().trim().indexOf(this.searchTerm.toLowerCase().trim()) > -1  || r.address.toLowerCase().trim().indexOf(this.searchTerm.toLowerCase().trim()) > -1 || r.city.toLowerCase().trim().indexOf(this.searchTerm.toLowerCase().trim()) > -1 || r.postcode.toLowerCase().trim().indexOf(this.searchTerm.toLowerCase().trim()) > -1) {
            return true;
          }

          return false;
        });
      }
      else {
        return this.retailers;
      }
    }
  },

  watch: {
    '$route' (to, from) {
      this.init();
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/Retailers/Retailers.js